import { useEffect } from 'react';
import type { CompanyProfileCarouselProfileFragment } from '~api';
import { EmployersCarousel } from '~features/employers-carousel';
import { useHostProps } from '~features/host-props';
import { useTrackingOnce } from '~features/tracking';
import { useFormatMessage } from '~i18n';
import { Platform } from '~types';

type Props = {
  profiles: CompanyProfileCarouselProfileFragment[] | undefined;
  loading: boolean;
};

const CAROUSEL_ITEMS_MIN_LENGTH_MOBILE = 2;
const CAROUSEL_ITEMS_MIN_LENGTH_DESKTOP = 4;

export const JobListingEmployersCarousel = ({ profiles, loading }: Props) => {
  const formatMessage = useFormatMessage();
  const { platform } = useHostProps();
  const { trackEventOnce } = useTrackingOnce();
  const itemsMinLength =
    platform === Platform.MOBILE
      ? CAROUSEL_ITEMS_MIN_LENGTH_MOBILE
      : CAROUSEL_ITEMS_MIN_LENGTH_DESKTOP;
  const noRelevantResults = (profiles || [])?.length < itemsMinLength;

  useEffect(() => {
    if (!loading && noRelevantResults) {
      trackEventOnce('company_carousel_results_incomplete');
    }
  }, [loading, trackEventOnce, noRelevantResults]);

  if (noRelevantResults) {
    return null;
  }

  return (
    <EmployersCarousel
      profiles={profiles}
      heading={
        formatMessage({
          id: 'comp.heading.employers_at_olx',
          defaultMessage: 'Employers at OLX',
        }) as string
      }
      headingLevel={3}
      loading={loading}
      target="_blank"
    />
  );
};
